/**
 * Static handles that should never render in the filter UI regardless of
 * page context. `part-number` is a backend lookup field that surfaces from
 * Nosto's facets but is not user-facing.
 */
export const STATIC_HIDDEN_FACET_HANDLES = new Set<string>(["part-number"])

/**
 * Normalize a facet name to a slug used for visibility comparisons (matching
 * the `data-nosto-hidden-facets` attribute values and the static set above).
 */
export function facetHandle(name: string | undefined): string {
  return (name ?? "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")
}
